var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.3999 6.455C16.6046 6.19429 16.898 6.03083 17.2145 6.00425C17.5296 5.97634 17.8433 6.08677 18.0835 6.30906C18.325 6.53148 18.4736 6.84946 18.4968 7.18955C18.52 7.5312 18.4163 7.86839 18.2077 8.12754L10.7218 17.5509C10.4995 17.8306 10.1776 17.9941 9.83652 18H9.81872C9.48448 18 9.16534 17.8484 8.94012 17.5819L5.31256 13.2987C4.86783 12.7746 4.90197 11.9618 5.38767 11.4818C5.87325 11.0032 6.62637 11.04 7.06976 11.5642L9.79007 14.7755L16.3999 6.455Z",
    fill: "#CC0FE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2145 6.00425C16.898 6.03083 16.6046 6.19429 16.3999 6.455L9.79007 14.7755L7.06976 11.5642C6.62637 11.04 5.87325 11.0032 5.38767 11.4818C4.90197 11.9618 4.86783 12.7746 5.31256 13.2987L8.94012 17.5819C9.16534 17.8484 9.48448 18 9.81872 18H9.83652C10.1776 17.9941 10.4995 17.8306 10.7218 17.5509L18.2077 8.12754C18.4163 7.86839 18.52 7.5312 18.4968 7.18955C18.4736 6.84946 18.325 6.53148 18.0835 6.30906C17.8433 6.08677 17.5296 5.97634 17.2145 6.00425Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerified);
export default __webpack_public_path__ + "static/media/iconVerified.15270e16.svg";
export { ForwardRef as ReactComponent };